<template>
  <li class="nav-item" role="presentation">
    <button
      class="nav-link text-secondary"
      :class="{ active: isActive }"
      :id="`${target}-tab`"
      type="button"
      role="tab"
      :aria-controls="target"
      :aria-selected="isActive.toString()"
      @click="setActive"
    >
      <slot></slot>
    </button>
  </li>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  target: { type: String, required: true },
  activeTab: { type: String, required: true },
});

const emit = defineEmits(["update:activeTab"]);

const isActive = computed(() => props.activeTab === props.target);

const setActive = () => {
  emit("update:activeTab", props.target);
};
</script>
